"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAvoidIsMobile = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../foundations");
/* WARNING
We should be using it as little as possible since it doesn't work on the server
and then guarantees layout shift. We should instead be trying to figure out
how to use css to hide/show so that it works on the server and client.
*/
const useAvoidIsMobile = () => {
    const theme = (0, foundations_1.useTheme)();
    const [isMobile, setIsMobile] = react_1.default.useState(() => typeof window !== "undefined"
        ? window.innerWidth <= parseInt(theme.breakpoints[0], 10)
        : false);
    react_1.default.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= parseInt(theme.breakpoints[0], 10));
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [theme]);
    return isMobile;
};
exports.useAvoidIsMobile = useAvoidIsMobile;
//# sourceMappingURL=useAvoidIsMobile.js.map